/* eslint-disable max-len,no-irregular-whitespace,no-console,react/no-unescaped-entities */
import React from 'react';
import Layout from '../../components/Layout';
import DrWatsonLargeLogo from '../../components/DrWatsonLargeLogo';
import SEO from '../../components/seo';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './style.scss';

const ShippingReturnsPage = () => (
    <Layout id="shipping-returns-page">
        <SEO title="Shipping & Returns" />
        <DrWatsonLargeLogo />
        <NavBar />

        <div className="nav-bar-below-content container">
            <div className="title is-size-4-touch is-size-3-desktop is-spaced">
                Shipping & Returns
            </div>
            <div className="subtitle is-size-6-touch is-size-5-desktop content">
                We offer FREE UK delivery on all orders over £30
                <br />
                <br />
                We operate a SAME DAY DISPATCH service on all orders placed before 2:00pm Monday to Friday (excluding
                bank holidays).
                <br />
                <br />
                Orders placed after 2:00pm Friday are shipped out on Monday (excluding bank holidays).
                <br />
                <br />
                <div className="title is-size-6-touch is-size-5-desktop">UK Mainland</div>

                All orders to the UK mainland are sent by Royal Mail
                <br />
                <br />
                The various delivery options and prices available at checkout are:
                <br />
                <br />
                <strong>Royal Mail 1st class (2-3 working days)</strong>
                <ul>
                    <li>Product shipped daily Monday through Friday</li>
                    <li>Same day dispatch on orders before 2PM</li>
                    <li>£2.99 on all order under £30.00</li>
                </ul>


                <strong>Royal Mail Tracked 24 (with or without signature)</strong>
                <ul>
                    <li>£4.99 Royal mail Tracked 24 aims to delivery within the next working day</li>
                    <li>
Royal Mail Tracked 24 & Tracked 24 with Signature aim to deliver your parcel the next working day and
                        includes full online tracking, SMS/email recipient notifications and a Safeplace option if no one is
                        home.
                    </li>
                </ul>
                <br />
                <div className="title is-size-5-touch is-size-4-desktop">Important</div>
                All orders are sent in discreet packaging.
                <br />
                <br />
                Orders placed after the 2:00pm cut off will be processed the next working day, (excluding Sundays and
                Bank Holidays)
                <br />
                <br />
                We do not offer delivery on Sundays or Bank Holidays.
                <br />
                <br />
                Orders to Northern Ireland, Scottish Highlands and most Channel Islands will be sent by Royal Mail and
                may take an extra working day
                <br />
                <br />
                Notes made at the checkout concerning delivery requests can't be relayed and won't be seen by the
                delivery drivers. This order notes facility is just to let us know of anything specific to do with your
                order.
                <br />
                <br />
                If your order hasn't arrived within the specified time frame shown for the delivery method chosen then
                please contact us within 10 days of the date we dispatched your order so we can investigate with the
                relevant handler.
                <br />
                <br />
                Unfortunately we are unable to investigate or replace any missing deliveries notified to us after 10
                working days.
                <br />
                <br />
                If there is a discrepancy with your delivery, please contact us immediately so we can help resolve any
                issues.
                <br />
                <br />
                <div className="title is-size-5-touch is-size-4-desktop">International</div>
                We offer FREE International delivery on all orders over £40
                We operate a SAME DAY DISPATCH service on all orders placed before 2:00pm Monday to Friday (excluding
                bank holidays). Orders placed after 2:00pm Friday are shipped out on Monday (excluding bank holidays).
                <br />
                <br />
                Royal Mail International Tracked and Signed/ Tracked or signed (might vary depending on your country)
                <ul>
                    <li>3 – 15 Days</li>
                    <li>3 - 15 Days at a fixed rate of £9.99 per shipment.</li>
                </ul>
                <br />
                Imports of vaping equipment can sometimes be difficult to receive and we can not be held responsible for
                any customs issues, tax or duties which your local office imposes.
                <br />
                <br />
                Please ensure your destination country allows the import of e-liquids or batteries before placing your
                order. If an item is seized by your local customs office this is the responsibility of the customer to
                resolve the issue.
                <br />
                <br />
                If an item is returned to us by the customs office, we will issue a refund minus any postage and custom
                costs or fees incurred by ourselves.
                <br />
                <br />
                We are bound by Royal Mail's terms and conditions which are listed on their website. If an item doesn't
                arrive within the estimated timeframe, we have to wait for up to 25 days before a claim can be made.
                <br />
                <br />
                As always if you have any questions please do not hesitate to get in touch with us using our CONTACT US
                form and we'll be happy to help. If you have already placed an order, please put your order number in
                the Subject line
                <br />
                <br />
                <br />
                <br />
            </div>
        </div>
        <Footer />

    </Layout>
);

export default ShippingReturnsPage;
